export type ItemsTableValidationMessages = {
  quantityRequired: string;
  quantityMoreThanZero: string;
  netUnitPriceRequired: string;
  netUnitPriceMoreThanZero: string;
  netLineAmountRequired: string;
  netLineAmountMoreThanZero: string;
  invalidNetLineAmountValue: string;
  userCommentRequired: string;
};

export const ITEMS_TAB_VALIDATION: ItemsTableValidationMessages = {
  quantityRequired: "Quantidade é obrigatória.",
  quantityMoreThanZero: "Quantidade deve ser maior que zero.",
  netUnitPriceRequired: "Valor unitário líquido é obrigatório.",
  netUnitPriceMoreThanZero: "Valor unitário líquido deve ser maior que zero.",
  netLineAmountRequired: "Valor líquido da linha é obrigatório.",
  netLineAmountMoreThanZero: "Valor líquido da linha deve ser maior que zero.",
  invalidNetLineAmountValue: "A soma dos valores não coincide com o pagamento esperado.",
  userCommentRequired: "Comentário é obrigatório para este produto.",
};
